import { useTranslation } from 'react-i18next';
import '../../../../../css/web/bedloophotel/faqs.css';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';

const CabeceraFaqs = ({ ruta, lang }) => {
    var imagen = ruta + "/faqs/cabecera/cabecera.jpg";

    const { t } = useTranslation();

    return (
        <>
            <CabeceraPagina titulo={t("Preguntas frecuentes")} eyebrow={t("Ayuda")} imagen={imagen} />
        </>
    );
}

export default CabeceraFaqs;
